import {AgregarExterno} from "./AgregarExterno";
import {postExternMta, putExternMta} from "../../../services/familia/mta";

export const AddExternoMta = () => {
    return (
        <AgregarExterno post={postExternMta} familiaURL={"/familia/mta"} name={"Movimiento Teresiano Apostólico"} logo={"logoMTA.png"} put= {putExternMta}/>
    )
}